import { getApiClient } from '..';
import withAuthenticationHeaders from '../../utilities/withAuthenticationHeaders';

type FetchAuthorizationParams = {
  key: string;
  sessionId: string;
  organizationId: string;
};

export default function fetchAuthorization({
  key, sessionId, organizationId,
}: FetchAuthorizationParams): Promise<io.flow.v0.unions.Authorization> {
  return getApiClient().authorizations.getByKey({
    key,
    organization: organizationId,
    headers: withAuthenticationHeaders(sessionId),
  }).then((response) => {
    if (response.ok) {
      return response.body;
    }
    throw new Error(`handleOgAuthInlineAction: Failed to feth Authorization ${key}`);
  });
}
